import React, { useImperativeHandle } from 'react';
import { useState, useEffect } from 'react';

import { Paragraph2 } from 'inpock-ui-react';

interface TimerProps {
  min: number;
  sec: number;
  onTimeOut: () => void;
}
export interface TimerForwardedRef {
  reset: () => void;
  clear: () => void;
}

export const Timer = React.forwardRef<TimerForwardedRef, TimerProps>(
  ({ min, sec, onTimeOut }, ref) => {
    const [second, setSecond] = useState(min * 60 + sec);
    const [timer, setTimer] = useState(setInterval(() => null));
    useImperativeHandle(ref, () => ({
      reset,
      clear,
    }));
    useEffect(() => {
      if (second === 0) {
        clearInterval(timer);
        onTimeOut();
      }
    }, [onTimeOut, second, timer]);
    const startTimer = () => {
      setTimer(
        setInterval(() => {
          setSecond((value) => value - 1);
        }, 1000),
      );
    };
    useEffect(() => {
      startTimer();
    }, []);
    const reset = () => {
      clear();
      setSecond(min * 60 + sec);
      startTimer();
    };
    const clear = () => {
      clearInterval(timer);
    };

    return (
      <Paragraph2 className="text-orange">
        입력시간{' '}
        {Math.floor(second / 60)
          .toString()
          .padStart(2, '0')}
        :{(second % 60).toString().padStart(2, '0')}
      </Paragraph2>
    );
  },
);
